import instance from "./instance";

const StockCompositionAPI = (params) => {
  return instance.get(`/komposisi-saham?orderBy=desc&limit=100&page=1`);
};

export default StockCompositionAPI;
